import getEmailPrimaryBlockTranslation from "./getEmailPrimaryBlockTranslation";

export const emailTranslatableBlockTags = [
  "mj-text",
  "mj-button",
  "mj-image",
  "mj-gif",
  "mj-raw",
  "mj-social",
  "mj-rating",
  "mj-preview",
  "mj-subject",
  "mj-feed-block",
] as const;

export function addEmailSpecialBlockTranslation(
  definition: any,
  props: {
    block: any;
    previousUid: string;
    translations?: any;
    primaryTranslation?: any;
  }
) {
  if (
    definition.langs &&
    emailTranslatableBlockTags.includes(props.block.tagName)
  ) {
    const translations = props.translations;
    if (translations && Object.keys(translations).length > 0) {
      for (const lang of definition.langs) {
        if (!lang.key) continue;
        if (
          translations[lang.key] &&
          translations[lang.key][props.previousUid]
        ) {
          lang.translations[props.block.uid] =
            translations[lang.key][props.previousUid];
        } else {
          if (lang.primary) {
            const firstKey = Object.keys(translations)[0] as string;
            const primaryTranslation =
              props.primaryTranslation || translations[firstKey];
            lang.translations[props.block.uid] =
              primaryTranslation[props.previousUid] || {};
          } else {
            lang.translations[props.block.uid] = {};
          }
        }
      }
    } else {
      const block = JSON.parse(JSON.stringify(props.block));
      if (
        definition.langs &&
        definition.langs.length > 0 &&
        emailTranslatableBlockTags.includes(block.tagName)
      ) {
        for (const lang of definition.langs) {
          if (lang.primary) {
            lang.translations[block.uid] =
              getEmailPrimaryBlockTranslation(block);
          } else {
            lang.translations[block.uid] = {};
          }
        }
      }
    }
  }
}
